module.exports = {"data":{"site":{"siteMetadata":{"title":"Internet of Blockchains","description":"A Gatsby.js Starter based on Dimension by Gab Rigo inspired by HTML5UP"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 114
// module chunks = 60335399758886 114276838955818